import type { Standardprofil } from "./types.js";

/** EFH Neubau Gehoben — hoeherwertige Materialien + 3-fach-Verglasung Ug=0.5. */
const profil: Standardprofil = {
  id: "efh-neubau-gehoben",
  name: "EFH Neubau Gehoben",
  projektart: "Neubau",
  qualitaetsstandard: ["Gehoben", "Premium"],
  gewerke: {
    rohbau: {
      description:
        "Aussenwand KS d=24cm + WDVS 18cm. Innenwaende KS d=17.5cm. Decken 22cm.",
      kriterien: {
        mauerwerksart_aussen: "Kalksandstein",
        wandstaerke_aussen_mm: 240,
        mauerwerksart_innen: "Kalksandstein",
        wandstaerke_innen_mm: 175,
        decke_material: "Stahlbeton",
        decke_dicke_mm: 220,
        wdvs_daemmstoffdicke_mm: 180,
      },
    },
    putz: {
      description: "Innen Kalk-Zement-Glaette, aussen Edelputz auf WDVS.",
      kriterien: {
        innen_typ: "Kalk-Zement-Glaette",
        innen_schichtdicke_mm: 12,
        aussen_typ: "Edelputz mineralisch",
        aussen_schichtdicke_mm: 8,
      },
    },
    maler: {
      description: "Diffusionsoffene Premium-Wandfarbe, hochdeckend.",
      kriterien: {
        beschichtung: "Diffusionsoffene Premium-Wandfarbe",
        anstriche: 2,
        deckkraft_klasse: 1,
      },
    },
    fliesen: {
      description: "Hochwertige Fliesen, Naturstein in Bad moeglich.",
      kriterien: {
        boden_rutschhemmung: "R10",
        boden_format_cm: "60x60 oder grossformatig 80x80",
        wand_typ: "Feinsteinzeug poliert oder Naturstein",
        verbund_abdichtung: "Pflicht",
      },
    },
    boden: {
      description: "Echtholzparkett geoelt oder Naturstein.",
      kriterien: {
        wohnen_typ: "Parkett",
        wohnen_klasse: "Eiche Landhausdiele 14mm",
        flur_typ: "Naturstein",
      },
    },
    estrich: {
      description: "Heizestrich CAF-C30-F5 fuer Fussbodenheizung.",
      kriterien: {
        typ: "Calciumsulfat-Fliessestrich CAF-C30-F5",
        dicke_mm: 65,
        fussbodenheizung: "Pflicht",
        randdaemmstreifen: "Pflicht",
      },
    },
    trockenbau: {
      description: "Beplankung 2x GKBI 12.5mm in feuchten Bereichen.",
      kriterien: {
        staendertyp: "CW 75",
        beplankung: "2x GKBI 12.5mm in Bad/HWR, sonst 2x GKB",
        daemmung_mm: 80,
      },
    },
    decke: {
      description: "Akustikdecke optional, sonst spachtelfertig.",
      kriterien: {
        unterkonstruktion: "Metall CD 60",
        beplankung: "1x GKB 12.5mm",
        spachtel_klasse: "Q3",
      },
    },
    tueren: {
      description: "Echtholz-Innentueren mit hoeherwertiger Beschlagsausstattung.",
      kriterien: {
        material: "Echtholz furniert",
        breite_mm: 875,
        hoehe_mm: 2110,
        zarge: "Blockzarge",
      },
    },
    fenster: {
      description: "Holz-Aluminium-Fenster mit 3-fach Verglasung Ug=0.5.",
      kriterien: {
        rahmenmaterial: "Holz-Aluminium",
        verglasung: "3-fach",
        ug_w_m2k: 0.5,
        uf_w_m2k: 0.8,
      },
    },
  },
};

export default profil;
